import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e8881b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-issues" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switch-label" }, "Toon gesloten meldingen:", -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { ls } from '@/ls'
import Column from '@/types/column'
import TableSettings from '@/types/tableSettings'
import axios from 'axios'
import { issueStore } from '@/stores/issue'
import PageTitleBar from '@/components/PageTitleBar.vue'
import { WarningTwoTone } from '@ant-design/icons-vue'
import { closedIssueStates, issueTypes, issueTypesArray } from '@/helpers/issueStates'
import ColumnSettings from '@/components/ColumnSettings.vue'
import FilterBox from '@/components/FilterBox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyIssues',
  setup(__props) {

const router = useRouter()
const myIssueTypesArray = issueTypesArray.filter((type) => ![2, 3].includes(type.id))

const columns = ref([
  {
    title: '#',
    key: 'id',
    sorter: true
  },
  {
    title: 'Type',
    key: 'type',
    filters: myIssueTypesArray.map((type) => ({
      text: type.name,
      value: type.id
    }))
  },
  {
    title: 'Onderwerp',
    key: 'title'
  },
  {
    title: 'Bedrijf',
    key: 'entity.id',
    sorter: false
  },
  {
    title: 'Project',
    key: 'project.id',
    filters: [],
    sorter: false
  },
  {
    title: 'Bouwnummer',
    key: 'building.number',
    sorter: true
  },
  {
    title: 'Adres',
    key: 'address'
  },
  {
    title: 'Gemeld op',
    key: 'created_at',
    sorter: true,
    width: 150
  },
  {
    title: 'Toegewezen aan',
    key: 'solver',
    filters: []
  },
  {
    title: 'Afspraak op',
    key: 'appointment_at',
    sorter: true,
    width: 150
  },
  {
    title: 'Oplossen voor',
    key: 'estimate',
    sorter: true,
    width: 150
  },
  {
    title: 'Status',
    key: 'status',
    sorter: false,
    filters: []
  }
])

const hiddenColumns = ref<string[]>([])
const filteredColumns = computed(() => {
  return columns.value.filter(c => !hiddenColumns.value.includes(c.key))
})

const tableSettings = ref<TableSettings>(ls.get('MyIssuesTableSettings') || {
  pagination: { current: 1, pageSize: 25 },
  showSizeChanger: true,
  pageSizeOptions: ['25', '50', '100'],
  activeFilters: {},
  sort: null,
  search: null,
  archived: false
})

onMounted(() => {
  issueStore().getMyIssues(tableSettings.value)
  getFilters()
  onTableSettingsChange()
})

function getFilters () : void {
  getProjectFilter()
}

function getProjectFilter () : void {
  axios.post(process.env.VUE_APP_API_URL + '/filters/project/issues', { textColumn: 'name', valueColumn: 'id' }).then((r) => {
    columns.value[4].filters = r.data
  })
}

function getIssueTypeText (type:number) : string {
  return issueTypes[type]
}

function getIssueStatusId (status:number|{ id:number }) : number {
  return typeof status === 'number' ? status : status.id
}

function checkIfOverdue (issue:{ estimate:string|null, status:number|{ id:number } }) : boolean {
  return issue.estimate !== null && new Date(issue.estimate).getTime() < new Date().getTime() && !closedIssueStates.includes(getIssueStatusId(issue.status))
}

function checkIfAlmostOverdue (issue:{ estimate:string|null, status:number|{ id:number } }) : boolean {
  if (!issue.estimate) {
    return false
  }

  const TenDaysBeforeEstimate = new Date(issue.estimate)
  TenDaysBeforeEstimate.setDate(TenDaysBeforeEstimate.getDate() - 10)
  return issue.estimate !== null && new Date().getTime() >= TenDaysBeforeEstimate.getTime() && !closedIssueStates.includes(getIssueStatusId(issue.status))
}

function getRowClassName (issue:{ estimate:string|null, status:number|{ id:number } }) : string {
  if (checkIfOverdue(issue)) {
    return 'warning-red'
  } else if (checkIfAlmostOverdue(issue)) {
    return 'warning-orange'
  }

  return ''
}

function onRowClick (record:{ id:number }) : { onClick: () => void } {
  return {
    onClick: () => {
      router.push({ name: 'IssueShow', params: { issueId: record.id.toString() } })
    }
  }
}

watch(() => tableSettings, () => {
  onTableSettingsChange()
}, { deep: true })

function handleTableChange (pagination:{ current:number, pageSize:number }, filters:{[key: string]: number[]|string[]}, sort:{ columnKey:string, order:string }) : void {
  if (filters && Object.keys(filters).length) {
    Object.keys(filters).forEach((key) => {
      if (!filters[key] || !filters[key].length) {
        delete filters[key]

        columns.value.forEach((column:Column) => {
          if (column.key === key) {
            column.filteredValue = null
          }
        })
      }
    })
  }

  tableSettings.value.pagination = pagination
  tableSettings.value.activeFilters = filters
  tableSettings.value.sort = sort.order ? sort : null

  issueStore().getMyIssues(tableSettings.value)
}

function handleSearchChange (searchTerm:string) : void {
  tableSettings.value.search = searchTerm
  tableSettings.value.pagination.current = 1
  issueStore().getMyIssues(tableSettings.value)
}

function onTableSettingsChange () : void {
  ls.set('MyIssuesTableSettings', tableSettings.value)

  axios.post(process.env.VUE_APP_API_URL + '/users/constructionSiteApp/settings', {
    settingName: 'MyIssuesTableSettings',
    settingValue: tableSettings.value
  })

  columns.value.forEach((column:Column) => {
    if (tableSettings.value.activeFilters && column.key in tableSettings.value.activeFilters) {
      column.filteredValue = tableSettings.value.activeFilters[column.key]
    } else {
      column.filteredValue = null
    }

    if (tableSettings.value.sort && column.key === tableSettings.value.sort.columnKey) {
      column.defaultSortOrder = tableSettings.value.sort.order
      column.sortOrder = tableSettings.value.sort.order
    } else {
      column.sortOrder = false
    }
  })
}

function updateFilters (activeFilters:{[key: string]: number[]|string[]}) : void {
  tableSettings.value.activeFilters = activeFilters
  issueStore().getMyIssues(tableSettings.value)
}

function archivedChanged () : void {
  if (tableSettings.value.activeFilters?.status) {
    delete tableSettings.value.activeFilters.status
  }

  issueStore().getMyIssues(tableSettings.value)
}

const pagination = computed(() => {
  return {
    current: tableSettings.value.pagination.current,
    defaultPageSize: tableSettings.value.pagination.pageSize,
    pageSize: parseInt(issueStore().issues.meta.per_page),
    total: issueStore().issues.meta.total,
    showTotal: (total:number, range:number[]) => `Melding ${range[0]} t/m ${range[1]} van de ${total}`,
    showSizeChanger: tableSettings.value.showSizeChanger,
    pageSizeOptions: tableSettings.value.pageSizeOptions
  }
})

function setColumnFilters (key:string, filters:Column['filters']) : void {
  const column = columns.value.find(obj => obj.key === key)
  if (column) column.filters = filters
}

function updateIssueFilterColumns () : void {
  const filters = issueStore().issueFilters
  setColumnFilters('status', filters.status)
  setColumnFilters('solver', filters.assignees)
}

watch(() => issueStore().issueFilters, () => {
  updateIssueFilterColumns()
}, { deep: true, immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Mijn meldingen.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(ColumnSettings, {
          columns: columns.value,
          storageName: "hiddenMyIssueColumns",
          onHiddenColumnsChanged: _cache[0] || (_cache[0] = ($event: any) => (hiddenColumns.value = $event))
        }, null, 8, ["columns"]),
        _createVNode(_component_a_switch, {
          checked: tableSettings.value.archived,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((tableSettings.value.archived) = $event)),
          onChange: archivedChanged
        }, null, 8, ["checked"]),
        _createTextVNode(),
        _hoisted_2
      ]),
      search: _withCtx(() => [
        _createVNode(_component_a_input_search, {
          placeholder: "Zoeken..",
          style: {"width":"100%"},
          value: tableSettings.value.search,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((tableSettings.value.search) = $event)),
          onSearch: handleSearchChange,
          "enter-button": "",
          "allow-clear": ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(FilterBox, {
      view: "myIssues",
      "active-filters": tableSettings.value.activeFilters,
      columns: columns.value,
      onUpdate: updateFilters
    }, null, 8, ["active-filters", "columns"]),
    _createVNode(_component_a_table, {
      columns: _unref(filteredColumns),
      "data-source": _unref(issueStore)().issues.data,
      loading: _unref(issueStore)().loading.list,
      rowKey: "id",
      customRow: onRowClick,
      rowClassName: getRowClassName,
      scroll: { x: true },
      pagination: _unref(pagination),
      onChange: handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.id), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(getIssueTypeText(record.type)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'title')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(record.title), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'entity.id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(record.project?.entity ? record.project.entity.name : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'project.id')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(record.project ? record.project.name : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'building.number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(record.building ? record.building.number : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'address')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createTextVNode(_toDisplayString(record.building ? record.building.address + ', ' + record.building.zipcode + ' ' + record.building.city : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'created_at')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _createTextVNode(_toDisplayString(record.created_at ? new Date(record.created_at).toLocaleDateString('nl-NL') : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'solver')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
              _createTextVNode(_toDisplayString(record.solver ? record.solver.full_name : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'appointment_at')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
              _createTextVNode(_toDisplayString(record.appointment_at ? new Date(record.appointment_at).toLocaleDateString('nl-NL') : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'estimate')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
              (checkIfOverdue(record))
                ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                    key: 0,
                    "two-tone-color": "red",
                    style: {"margin-right":"8px"}
                  }))
                : (checkIfAlmostOverdue(record))
                  ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                      key: 1,
                      "two-tone-color": "#f38929",
                      style: {"margin-right":"8px"}
                    }))
                  : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(record.estimate ? new Date(record.estimate).toLocaleDateString('nl-NL') : '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 11,
              class: _normalizeClass(["issue-status-tag", record.status.class])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.status.name), 1)
              ]),
              _: 2
            }, 1032, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "pagination"])
  ]))
}
}

})